import './ServiceOrderItems.scss';

import type { FormProps } from 'antd';
import { Form } from 'antd';
import { type Dispatch, type SetStateAction, useMemo } from 'react';

import { ServiceOrderItem } from '@/model/ServiceOrder/ServiceOrderItem';

import ServiceOrderShippedItems from './ServiceOrderShippedItems/ServiceOrderShippedItems';
import ServiceOrderItemsStockSection from './ServiceOrderTechnicianStock/ServiceOrderTechnicianStock';
import useServiceOrderItemsForm from './useServiceOrderItemsForm';

interface ServiceOrderItemsProps {
  formProps?: FormProps;
  // Tickets de la orden cuando no hay un Form padre del cual derivarlos (ej: Drawer del Show).
  tickets?: (number | string)[];
  serviceOrderItems: ServiceOrderItem[];
  // Permite updates funcionales para evitar sobreescrituras.
  setServiceOrderItems: Dispatch<SetStateAction<ServiceOrderItem[]>>;
  // Indica si la orden ya existe (Show/Edit) para cargar sus items ya guardados.
  hasExistingServiceOrder?: boolean;
  onInvalidDistributionChange?: (hasInvalid: boolean) => void;
}

const FormValue = () => null;
const ServiceOrderItems = (props: ServiceOrderItemsProps) => {
  const {
    formProps,
    tickets: fixedTickets,
    serviceOrderItems,
    setServiceOrderItems,
    hasExistingServiceOrder = false,
    onInvalidDistributionChange,
  } = props;
  const watchedTickets = Form.useWatch('tickets', formProps?.form);
  const tickets = formProps ? watchedTickets : fixedTickets;
  const { shippedItems, isLoading } = useServiceOrderItemsForm(
    serviceOrderItems,
    setServiceOrderItems,
    tickets,
    hasExistingServiceOrder,
  );
  const serviceOrderItemsFromPackage = useMemo(
    () => serviceOrderItems.filter(so => so.package_item),
    [serviceOrderItems],
  );
  const serviceOrderItemsFromTechnician = useMemo(
    () => serviceOrderItems.filter(so => !so.package_item),
    [serviceOrderItems],
  );

  return (
    <div className="ServiceOrderItems">
      <ServiceOrderShippedItems
        serviceOrderItems={serviceOrderItemsFromPackage}
        setServiceOrderItems={setServiceOrderItems}
        shippedItems={shippedItems}
        isLoading={isLoading}
        tickets={tickets ?? []}
        onInvalidDistributionChange={onInvalidDistributionChange}
      />
      <ServiceOrderItemsStockSection
        serviceOrderItems={serviceOrderItemsFromTechnician}
        setServiceOrderItems={setServiceOrderItems}
      />
      {formProps && (
        <Form.Item name="service_order_items" hidden>
          <FormValue />
        </Form.Item>
      )}
    </div>
  );
};

export default ServiceOrderItems;
